@if(isLoading()){
  <div class="select-placeholder-container">
    <span> {{ 'loading' | translate }}</span>
    <mat-spinner class="spinner" diameter="20"></mat-spinner>
  </div>
}
